/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_CopyInputs */



/**
* | output |
* | --- |
* | "Copy (no transcode)" |
*
* @param {Audio_Embed_Export_Codec_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_copy = /** @type {((inputs?: Audio_Embed_Export_Codec_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copie (sans transcodage)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopieren (keine Transkodierung)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia (senza transcodifica)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копирование (без перекодирования)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar (sin transcodificar)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制（无需转码）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コピー（トランスコードなし）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कॉपी करें (ट्रांसकोड नहीं)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar (sem transcodificação)")
	return /** @type {LocalizedString} */ ("Copy (no transcode)")
});